export default "__VITE_ASSET__DgT3cru1__"